import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const hashicorpConsul = defineConnector({
  identifier: "hashicorpConsul",
  name: "HashiCorp Consul",
  tagLine: "Service networking platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.hashicorp\\.cloud/.*",
  auth: (app) =>
    headerAuth([{ name: "X-Consul-Token", value: app.secret.aclToken }]),
  steps: [
    {
      title: "Enter your Consul instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "consul.your-company.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Enter your ACL token",
      items: [
        {
          kind: "markdown",
          content:
            "Create an ACL token with the appropriate policies in Consul. See the [API docs](https://developer.hashicorp.com/consul/api-docs) for details.",
        },
        {
          kind: "input",
          label: "ACL token",
          required: true,
          target: { kind: "secrets", field: "aclToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/v1/agent/members`,
  },
});
